// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"1795bf43","484":"1ab3ac05","551":"cdc243e9","849":"9af22534"}[chunkId] + ".chunk.js";
};